/**
 * SGKC009A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Sgkc009aReqTankatableCancelInfoDto {

    /**
     * 単価表登録管理通番
     */
    tankatableregistrationManagementserialnumber?: string;
    /**
     * 更新通番号
     */
    updateSrno?: string;
}

